import React from 'react';
import {Line} from 'react-chartjs-2';
import {
    CategoryScale,
    Chart as ChartJS,
    Legend,
    LinearScale,
    LineElement,
    PointElement,
    Title,
    Tooltip
} from 'chart.js';
import {centsToString} from 'util/cashFormatter';

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend);

const MonthlyPriceGraph = ({tradeData}) => {
    const twelveMonthsTrades = tradeData?.twelveMonthsTrades.sort((a, b) => {
        const dateA = new Date(a.label);
        const dateB = new Date(b.label);
        return dateA - dateB;
    }) || [];

    const monthNames = [
        'January', 'February', 'March', 'April', 'May', 'June',
        'July', 'August', 'September', 'October', 'November', 'December'
    ];

    const labels = twelveMonthsTrades.map(trade => {
        const [year, month] = trade.label.split('-');
        const monthName = monthNames[parseInt(month, 10) - 1];
        return `${monthName} ${year}`;
    });

    const prices = twelveMonthsTrades.map(trade => trade.averagePrice);
    const sales = twelveMonthsTrades.map(trade => trade.volume);
    const minPrices = twelveMonthsTrades.map(trade => trade.lowestPrice);
    const maxPrices = twelveMonthsTrades.map(trade => trade.highestPrice);

    const chartData = {
        labels: labels,
        datasets: [
            {
                label: 'Average Price',
                data: prices,
                borderColor: 'rgba(75, 192, 192, 1)',
                backgroundColor: 'rgba(75, 192, 192, 0.2)',
                fill: true,
                tension: 0.3,
            },
            {
                label: 'Min Price',
                data: minPrices,
                borderColor: 'rgba(255, 99, 132, 1)',
                backgroundColor: 'rgba(255, 99, 132, 0.2)',
                fill: false,
                tension: 0.3,
            },
            {
                label: 'Max Price',
                data: maxPrices,
                borderColor: 'rgba(54, 162, 235, 1)',
                backgroundColor: 'rgba(54, 162, 235, 0.2)',
                fill: false,
                tension: 0.3,
            },
        ],
    };

    const options = {
        interaction: {
            mode: 'x',
            intersect: false
        },
        scales: {
            y: {
                beginAtZero: true,
                min: 0,
                ticks: {
                    callback: value => `${centsToString(value)}`
                }
            },
        },
        plugins: {
            tooltip: {
                callbacks: {
                    label: (context) => {
                        const price = context.raw;
                        const sale = sales[context.dataIndex];
                        if (context.dataset.label === 'Average Price') {
                            return `${sale} Transactions with Average Price: ${centsToString(price)}`;
                        } else {
                            return `${context.dataset.label}: ${centsToString(price)}`;
                        }
                    },
                },
            },
        },
    };

    return <Line data={chartData} options={options}/>;
};

export default MonthlyPriceGraph;